import React, { useCallback, useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import useRealtimeSync from "../../hooks/useRealtimeSync";
import { lastQuery } from "../../helper/lastQuery";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAgentAction,
  GetCatalogAction,
  GetContractTypeAction,
  GetCountryAction,
  GetProgramAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import Message from "../../Icon/Message";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate, useParams } from "react-router-dom";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import {
  DeleteProgAvailableService,
  EditProgAvailableService,
  DeleteBulkProgramService,
} from "../../Redux/service/SettingService";
import { Edit, ExpandLess, ExpandMore } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const ProgramlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [Programlist, setProgramlist] = useState([]);

  const [isToggled, setIsToggled] = useState(false);

  const [table_load, setTable_load] = useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [Degreelist, setDegreelist] = useState([]);

  const [Universitylist, setUniversitylist] = useState([]);

  const [FilterProglist, setFilterProglist] = useState([]);

  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [deleteconfirmationopen, setDeleteConfirmationOpen] = useState(false);
  const [bulkDeleteOpen, setBulkDeleteOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [deleteId, setDeleteId] = useState();
  const [Countrylist, setCountrylist] = useState([]);

  const [contractTypelist, setContractTypelist] = useState([]);
  const [expanded, setExpanded] = useState({});

  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    let data = {
      page: page,
      limit: pagination.limit,
    };
    reload(undefined, data);
    // fetchData(page, pagination.limit);
  };
  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload(undefined, { page: 1, limit: newLimit });
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const CountrylistState = useSelector(
    (state) => state.setting?.countryCount?.data?.data
  );
  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const ProgramlistState = useSelector((state) => state.setting?.program?.data);

  const ContractTypeListState = useSelector(
    (state) => state.setting?.contractType?.data?.data
  );

  useEffect(() => {
    console.log(ProgramlistState?.pagination);
    if (ProgramlistState) {
      // const { data, pagination } = ProgramlistState;
      // setRows(data);
      setPagination(ProgramlistState?.pagination);
    }
  }, [ProgramlistState]);

  useEffect(() => {
    // console.log(CountrylistState)
    setCountrylist(
      CountrylistState?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      }))
    );
  }, [CountrylistState]);

  const toggleUniversity = (uni) => {
    setExpanded((prev) => ({ ...prev, [uni]: !prev[uni] }));
  };

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetCountryAction());
    dispatch(GetUniversityAction(data));
    dispatch(GetDegreeAction());
  }, []);

  useEffect(() => {
    setUniversitylist(
      UniversitylistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );

    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
    // setFilterProglist(
    //   ProgramlistState?.map(({ program, ...rest }) => ({
    //     title: program,
    //     ...rest,
    //   }))
    // );
  }, [UniversitylistState, DegreelistState, ProgramlistState]);

  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    if(id){
      string.push(`university=${id}`)
    }
    try {
      let response = await axios.get(
        basicurl + `/api/program/get-all-programs?${string.join("&")}&limit=${0}&page=${1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);

      setPagination(response.data?.pagination)

      setProgramlist(
        response?.data?.programs?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
      // setData(
      //   response.data.students?.map(({ _id, ...rest }) => ({
      //     id: _id,
      //     ...rest,
      //   }))
      // ); // Assuming the response structure has a `data` key
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetProgramAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetProgramAction(data));
  };

  const handleApplyFilters = applyFilters;

  useEffect(() => {
    dispatch(GetContractTypeAction());
  }, []);
  useEffect(() => {
    const updatedData = ContractTypeListState?.map(
      ({ contractType, ...rest }) => ({
        title: contractType,
        ...rest,
      })
    );
    setContractTypelist(updatedData);
  }, [ContractTypeListState]);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 80,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditProgram/${params.row.id}`);
        };
        return (
          <>
            {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
              window.sessionStorage.getItem("user_role_type") === "admin" ||
              window.sessionStorage.getItem("user_role_type") === "user") && (
                <Tooltip title="Edit Organization">
                  {" "}
                  <IconButton onClick={handleEditActionClick}>
                    <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
                  </IconButton>
                </Tooltip>
              )}
          </>
        );
      },
    },
    {
      field: "university",
      headerName: "University Name",
      width: 180,
      renderCell: (params) => {
        return (
          <div style={{ textDecoration: "underline" }}>
            {toTitleCase(params.row.university?.name)}
          </div>
        );
      },

      // renderCell: (params) => {
      //   const { row, value } = params;
      //   if (row.isGroup) {
      //     return (
      //       <div style={{ display: 'flex', alignItems: 'center' }}>
      //         <button onClick={() => toggleUniversity(value)} style={{ marginRight: 8 }}>
      //           {expanded[value] ? '▼' : '▶'}
      //         </button>
      //         <strong>{value}</strong>
      //       </div>
      //     );
      //   }
      //   return value;
      // },
    },
    {
      field: "ContarctType",
      headerName: "Contract Type",
      width: 100,
      renderCell: (params) => {
        return <div>{params.row.university?.contractType?.contractType}</div>;
      },
    },
    {
      field: "degree",
      headerName: "Degree Name",
      width: 150,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.degree?.name)}</div>;
      },
    },
    {
      field: "program",
      headerName: "Program name",
      width: 200,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.program)}</div>;
      },
    },
    {
      field: "state",
      headerName: "State",
      width: 150,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.university?.state)}</div>;
      },
    },
    {
      field: "city",
      headerName: "City",
      width: 100,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.university?.city)}</div>;
      },
    },

    {
      field: "country",
      headerName: "Country",
      width: 100,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.university?.country)}</div>;
      },
    },

    {
      field: "delete",
      headerName: "",
      width: 50,
      renderCell: (params) => {
        const handleDeleteProg = () => {
          setDeleteId(params.row.id);
          setDeleteConfirmationOpen(true);
        };
        return (
          <>
            {(window.sessionStorage.getItem("user_role_type") === "admin" ||
              window.sessionStorage.getItem("user_role_type") === "user") && (
                <Tooltip title="delete the program">
                  {" "}
                  <Box display="flex" alignItems="center" className="px-2 py-2">
                    <DeleteIcon
                      sx={{ color: "red" }}
                      onClick={handleDeleteProg}
                    />
                  </Box>
                </Tooltip>
              )}
          </>
        );
      },
    },
    {
      field: "blocked",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingActionClick = (event) => {
          event.stopPropagation();
          const newAvailableValue = !params.row.isAvailable;
          setProgramlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id ? { ...data, isAvailable: newAvailableValue } : data
            )
          );
          setChangeBlockStatusOfOrg({ id: params.row.id, isAvailable: newAvailableValue });
          setConfirmationOpen(true);
        };

        if (window.sessionStorage.getItem("user_role_type") !== "admin") return null;

        const isAvailable = !!params.row.isAvailable;
        return (
          <Box display="flex" alignItems="center" className="px-2">
            <Button
              size="small"
              variant="contained"
              onClick={handleBlockingActionClick}
              sx={{
                backgroundColor: isAvailable ? ThemeColor.PURPLE : ThemeColor.RED,
                color: ThemeColor.WHITE,
                textTransform: "none",
                minWidth: 90,
                '&:hover': {
                  backgroundColor: isAvailable ? ThemeColor.LIGHTPURPLE : '#c92b27',
                },
              }}
            >
              {isAvailable ? "Available" : "Unavailable"}
            </Button>
          </Box>
        );
      },
    },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   width: 150,
    //   renderCell: (params) => {
    //     const handleEditActionClick = (event) => {
    //       event.stopPropagation();
    //       navigate(`/CAE/EditCatalogandBrochure/${params.row.id}`);
    //     };
    //     return (
    //       <div className="d-flex" onClick={handleEditActionClick}>
    //         Edit
    //       </div>
    //     );
    //   },
    // },
  ];

  const fields = [
    // {
    //   label: "University Name",
    //   value: "university",
    //   type: "select",
    //   option: Universitylist,
    // },
    {
      label: "Degree",
      value: "degree",
      type: "multi-select",
      option: Degreelist,
    },
    ...(!id
      ? [
        {
          label: "University Name",
          value: "university",
          type: "multi-select",
          option: Universitylist,
        },
      ]
      : []),
    {
      label: "Program",
      value: "program",
      // type: "multi-select",
      // option:FilterProglist,
    },
    {
      label: "Country",
      value: "country",
      type: "multi-select",
      option: Countrylist,
    },
    {
      label: "State",
      value: "state",
    },
    { label: "City", value: "city", type: "text" },
    {
      label: "Contract Type",
      value: "contractType",
      type: "multi-select",
      option: contractTypelist,
    },
  ];

  //(ProgramlistState, "catalog data");

  useEffect(() => {
    dispatch({ type: "GetProgramList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    if (id) reload(id);
    else reload(undefined, data);
  }, [id]);

  // Someone else (or another screen) added, updated or deleted a program:
  // reload exactly the view the user is looking at.
  useRealtimeSync(
    "program",
    useCallback(() => {
      setTable_load(true);
      const q = lastQuery("program", { id, page: { page: 1, limit: 50 } });
      reload(q.id, q.page);
    }, [dispatch, id])
  );

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    const updatedData = ProgramlistState?.programs?.map(({ _id, ...rest }) => ({
      id: _id,
      // title: program,
      ...rest,
    }));
    setProgramlist(updatedData);
    setTable_load(false);
  }, [ProgramlistState]);

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={6} md={5} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Program List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} md={7} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="button"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setBulkDeleteOpen(true)}
                >
                  Bulk Delete
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>

                {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                  !window.sessionStorage.getItem("user_role_type") === "user") && (
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    onClick={() => navigate("/CAE/AddProgram")}
                  >
                    Add Program
                  </CustomButton>
                )}
              </Box>
            </Grid>
          </Grid>

          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={Programlist ? Programlist : []}
              columns={columns}
              loading={table_load}
              getRowClassName={(params) =>
                params.row.isAvailable ? "row-white" : "row-dull"
              }
              onSelectionChange={(newSelection) => setSelectedIds(newSelection)}
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setProgramlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isAvailable: changeBlockStatusOfOrg.isAvailable,
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditProgAvailableService(
                  changeBlockStatusOfOrg.isAvailable,
                  changeBlockStatusOfOrg.id
                );

                if (res.status === 200) {
                  reload(id);
                  setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          />

          {/* for delete */}
          {/* bulk delete confirmation */}
          <ConfirmationModal
            msg="Delete Selected"
            btnName="Delete"
            handleConfirmationClose={() => {
              setBulkDeleteOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await DeleteBulkProgramService(selectedIds);

                if (res.status === 200) {
                  reload(id);
                  setSelectedIds([]);
                  setBulkDeleteOpen(false);
                  return res;
                } else {
                  return Promise.reject("Unexpected response status");
                }
              } catch (e) {
                dispatch(
                  showSnackbar(e.response?.data?.message || "Error occurred", "error")
                );
                return e;
              }
            }}
            confirmationopen={bulkDeleteOpen}
            message={"Want to delete selected programs?"}
          />
          <ConfirmationModal
            msg="Delete"
            btnName="Delete"
            handleConfirmationClose={() => {
              // setProgramlist((prev) =>
              //   prev.map((data) =>
              //     data.id === changeBlockStatusOfOrg.id
              //       ? {
              //           ...data,
              //           isAvailable: changeBlockStatusOfOrg.isAvailable,
              //         }
              //       : data
              //   )
              // );
              setDeleteConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await DeleteProgAvailableService(deleteId);

                if (res.status === 200) {
                  reload(id);
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={deleteconfirmationopen}
            message={"Want to delete the program?"}
          />
        </>
      )}
    </div>
  );
};

function Programlist() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();

  const handleSearch = (searchValue) => {
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    if (id) {
      dispatch(GetProgramAction(id, data));
    }
    else {
      dispatch(GetProgramAction(undefined, data));

    }

    // dispatch(GetProgramAction(undefined,data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<ProgramlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default Programlist;
